import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

export function initAnalytics() {
  if (initialized || !KEY) return;
  try {
    posthog.init(KEY, {
      api_host: HOST,
      defaults: "2026-01-30",
      person_profiles: "identified_only",
      capture_pageview: true,
      autocapture: true,
      persistence: "localStorage+cookie",
      loaded: () => (initialized = true),
    });
  } catch (e) {
    // graceful no-op
  }
}

export function track(event, props) {
  if (!initialized || !KEY) return;
  try {
    posthog.capture(event, props || {});
  } catch (e) {
    /* no-op */
  }
}

export function identify(distinctId, props) {
  if (!initialized || !KEY) return;
  try {
    posthog.identify(distinctId, props || {});
  } catch (e) {
    /* no-op */
  }
}
